<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Puck page
@Last modified by:   tom
@Last modified time: 2019-06-12T17:23:43+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page id="preoderpage"
        :title="$t('puck.title')"
        :jbheader="$t('puck.subtitle')"
        :jblead="$t('puck.lead')"
        jbvariant="dark"
        :sideimage="assetUrl('img/puck/puck-chat.jpg')"
        zoom-modal>

    <!-- the payload -->

    <h1 class="text-secondary" v-html="$t('puck.about.title')" />

    <b-row no-gutters >
      <b-col md="9">
        <p v-html="$t('puck.about.subtext')"/>
      </b-col>
      <b-col>
        <!-- Price list button -->
        <b-button
          to="/prices/puck"
          size=""
          variant="warning"
          class="mb-4 float-right"
          v-html="$t('prices.header') "/>
      </b-col>
    </b-row>

    <workflow/>
    <puckslides/>
    <specifications/>
    <techbrands/>

  </c-page>
</template>

<script>
import Vue from 'vue'

// async loading, as not on home page, so we can have time
Vue.component('workflow', () => import('@/components/products/puck/Workflow'))
Vue.component('techbrands', () => import('@/components/products/TechBrands'))
Vue.component('puckslides', () => import('@/components/products/puck/PuckSlides'))
Vue.component('specifications', () => import('@/components/products/puck/Specifications'))

export default {
  name: 'Puck'
}
</script>

<style lang="scss" scoped>

</style>
